// Copyright (c) 2016 Deere & Company

import NewTransfer from '../../product/new-transfer/state-connector';

export default {
    component: NewTransfer,
    name: 'NEW_TRANSFER',
    path: 'new-transfer/:pin'
};




// WEBPACK FOOTER //
// ./src/routes/products/new-transfer.js